export default __webpack_public_path__ + "static/media/Todo.232e8696.jpg";